export const qualificationTypes = Object.freeze({
    REGIONAL: 'Regional',
    FINAL: 'Final',
    REGIONAL_WO: 'RegionalWO',
    FINAL_WO: 'FinalWO'
});

export const cellTypes = Object.freeze({
    POSITION: 'pos',
    MOVERS: 'movers',
    NATIONALITY: 'nationality',
    PLAYER: 'player',
    PAR: 'par',
    HOLE: 'hole',
    TOTAL: 'total',
    TODAY: 'today',
    R1: 'r1',
    R1_SCORE: 'r1Score',
    R1_OUT: 'r1Out',
    R1_IN: 'r1In',
    R1_TO_PAR: 'r1ToPar',
    R2: 'r2',
    R2_SCORE: 'r2Score',
    R2_OUT: 'r2Out',
    R2_IN: 'r2In',
    R2_TO_PAR: 'r2ToPar'
});

export const getCellModifierByType = (type) => {
    switch (type) {
        case cellTypes.R1_IN:
        case cellTypes.R2_IN:
            return 'in';
        case cellTypes.R1_OUT:
        case cellTypes.R2_OUT:
            return 'out';
        case cellTypes.R1_TO_PAR:
        case cellTypes.R2_TO_PAR:
            return 'today';
        case cellTypes.R1_SCORE:
        case cellTypes.R2_SCORE:
            return 'total';
        default:
            return type;
    }
};

export const getTitleByType = (type) => {
    switch (type) {
        case cellTypes.PAR:
            return 'to par';
        case cellTypes.TOTAL:
            return 'total';
        case cellTypes.HOLE:
            return 'holes';
        case cellTypes.R1_IN:
        case cellTypes.R2_IN:
            return 'in';
        case cellTypes.R1_OUT:
        case cellTypes.R2_OUT:
            return 'out';
        case cellTypes.R1_TO_PAR:
        case cellTypes.R2_TO_PAR:
            return 'rnd par';
        case cellTypes.R1_SCORE:
        case cellTypes.R2_SCORE:
            return 'rnd score';
        default:
            return type;
    }
};

export const deviceTypes = Object.freeze({
    MOBILE: 'mobile'
});

export const playerStatuses = Object.freeze({
    AMATEUR: 0,
    REINSTATED: 4
});

export const noFavoriteMessage = {
    title: 'Favourite players',
    body: 'You don\'t have any favourites added yet, click on the star button to add them.'
};

export const noResultsMessage = {
    title: 'No results',
    body: 'Please try making your search a little wider.'
};
